import Datetime from "components/shared/datetime";
import differenceInDays from "date-fns/differenceInDays";
import endOfToday from "date-fns/endOfToday";
import format from "date-fns/format";
import sub from "date-fns/sub";
import { relationToTypes, relationToTypesEnum } from "helpers/enums";
import React, { useState } from "react";
import { downloadArchive } from "sources/books/finance";

const today = endOfToday();

const MAX_DAYS_RANGE = 60;

export default function DownloadFilesByPeriod(props) {
    const [from, setFrom] = useState(sub(new Date(), { weeks: 1 }));
    const [to, setTo] = useState(new Date());
    const [relatedTo, setRelatedTo] = useState(relationToTypesEnum.Bid);
    const [loading, setLoading] = useState(false);

    const downloadFiles = () => {
        setLoading(true);
        const params = {
            from: format(new Date(from), "yyyy.MM.dd"),
            to: format(new Date(to), "yyyy.MM.dd"),
            documentType: props.type,
            relatedTo,
        };

        downloadArchive(params).then(() => setLoading(false));
    };

    const daysBetween = differenceInDays(new Date(to), new Date(from));

    return (
        <div className={loading ? "loading" : ""}>
            <div className="mb-2">
                <label className="col-form-label col-form-label-sm">Тип связанного объекта</label>
                <div className="d-flex pb-1">
                    <select
                        className="form-control form-control-sm"
                        value={relatedTo}
                        onChange={(e) => setRelatedTo(e.target.value)}
                    >
                        {relationToTypes.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="mb-2">
                <label className="col-form-label col-form-label-sm">Период</label>
                <div className="d-flex pb-1">
                    <Datetime
                        inPortal
                        libOptions={{ maxDate: to ? new Date(to) : today }}
                        inputProps={{ name: "from", type: "date" }}
                        value={from}
                        onChange={({ value }) => setFrom(value)}
                    />
                    <span className="px-3">&mdash;</span>
                    <Datetime
                        inPortal
                        libOptions={{ maxDate: today }}
                        inputProps={{ name: "to", type: "date" }}
                        value={to}
                        onChange={({ value }) => setTo(value)}
                    />
                </div>
                {daysBetween > MAX_DAYS_RANGE && (
                    <div className="text-danger small">Период не должен превышать 60 дней</div>
                )}
            </div>
            <div className="d-flex justify-content-end">
                <div className="btn btn-brand" onClick={downloadFiles}>
                    Скачать
                </div>
            </div>
        </div>
    );
}
